<template>
    <div class="about_us_box">
        <div class="about_us_wrap">
            <h2>ABOUT US</h2>
            <div class="line_bor"></div>
            <div class="top_txt_box">
                <p class="top_txt">ShanghaiEye, bringing stories to life, is a SMG-powered multi-platform media brand that includes a website; a social media footprint of 3 million; a TV channel with online live-streaming; and a ShanghaiEye+ co-operated with agencies include AP, Reuters, ENEX, NHK, RT, WAM and etc.</p>
                <p class="top_txt">With correspondents in Tokyo, Berlin, Dubai and the Washington D.C., ShanghaiEye covers news, in-depth reporting, documentary and commentary that welcomes diverse views and voices from global scholars and experts. We aim to build bridges by providing international viewers with a broader, more nuanced picture of China. </p>
                <p class="top_txt mar_b">Follow us on YouTube, X, Facebook, Instagram, and TikTok.</p>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from "@/components/common/layout/Footer.vue";

    export default {
        data(){
            return{

            }
        },
        mounted(){
            document.title = 'About Us | ShanghaiEye';
        },
        components: {
            Footer
        }
    }
</script>

<style lang='less' scoped>
    .about_us_box{
        .about_us_wrap{
            width: 70%;
            margin: 0 auto;
            h2{
                line-height: 1.2;
                font-family:FranklinGothic-Demi, sans-serif !important;
                letter-spacing: .05em;
                font-size: 40px;
                font-weight: bold;
                text-align: center;
                padding-top: 40px;
                padding-bottom: 20px;
                // border-bottom: 3px solid #ccc;
                margin-bottom: 0;
            }
            .line_bor{
                height: 4px;
                border-top: 1px solid #ccc;
                border-bottom: 1px solid #ccc;
            }
            .top_txt_box{
                padding:26px 20px;
            }
            .top_txt{
                font-size: 16px;
                font-family: "Open Sans";
                word-break: break-word;
                margin-bottom: 20px;
                letter-spacing: .05em;
                line-height: 30px;
                &.mar_b{
                    margin-bottom: 20px;
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        .about_us_box{
            .about_us_wrap{
                width: 100%;
            }
        }
    }
</style>